import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.js'
import './index.css'
import {DataProvider} from './redux/store.js'
import './i18n';



ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <React.Suspense fallback="loading...">
      <DataProvider>
        <App />
      </DataProvider>
    </React.Suspense>
  </React.StrictMode>
)
